import React from 'react';
import FormInput from '../form-input/form-input.component';
import CustomButton from '../custom-buton/custom-button.component';
import { auth, signInWithGoogle } from '../../firebase/firebase.utils';
import './sign-in.styles.scss';

class SignIn extends React.Component{
    constructor(props){
        super();
        this.state ={
            email:'',
            password:''
        }
    }
    handleSubmit =  async event => {
        event.preventDefault();

        const { email, password } = this.state;
        try{
            await auth.signInWithEmailAndPassword(email, password);
            this.setState({email:'',password:''});
        }catch(error){
            console.log(error);
        }
    };

   handleChange = event =>{
        const { name, value } = event.target;
        this.setState({[name]: value })

   };

    render(){
        return(
            <div className = 'sign-in'>
                <h2> I already have an account </h2>
                <span>Sign in with your eamil and password</span>
                <form onSubmit = {this.handleSubmit}>
                    <FormInput
                     name="email"
                    type="email" 
                    handleChange={this.handleChange}
                    label="Email"
                    value={this.state.email} required/>
                
                    <FormInput
                     name="password"
                    type="password"
                    label="Password"
                    handleChange={this.handleChange}
                    value={this.state.password} required/>
                    <div className='buttons'>  
                        <CustomButton type="submit" > Sign In </CustomButton>
                        <CustomButton type="button" onClick = {signInWithGoogle} isGoogleSignIn>Sign with Google</CustomButton>
                    </div>
                </form>
            
            </div>
        )
    }
}

export default SignIn;